import { createContext } from 'react';
import { TPolicyActionDispatch } from './actions/TPolicyActionDispatch';

export const PolicyDispatchContext = createContext<TPolicyActionDispatch>(() => {});
